export function formatAdvisorWhatsAppLink({
  message,
  number,
}: FormatAdvisorWhatsAppLink) {
  const url = new URL('https://api.whatsapp.com/send');
  url.searchParams.append('phone', number.replace(NO_WHITESPACES_REGEX, ''));
  url.searchParams.append('text', message);
  return url.toString();
}

const NO_WHITESPACES_REGEX = /\s/g;

type FormatAdvisorWhatsAppLink = {
  message: string;
  number: string;
};
